import React from 'react';

const SearchIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L24 0 24 24 0 24z"
                  transform="translate(-312 -120) translate(0 96) translate(312 24)"
                />
                <path
                  fill="#21272E"
                  d="M15.932 14.253h-.88l-.313-.3c1.338-1.56 2.029-3.688 1.65-5.949-.524-3.096-3.11-5.569-6.23-5.948-4.715-.579-8.682 3.386-8.103 8.098.38 3.119 2.854 5.703 5.952 6.226 2.262.38 4.39-.312 5.951-1.648l.301.312v.88l4.737 4.733c.457.457 1.203.457 1.66 0 .457-.456.457-1.202 0-1.66l-4.725-4.744zm-6.687 0c-2.775 0-5.015-2.239-5.015-5.012 0-2.774 2.24-5.013 5.015-5.013 2.775 0 5.015 2.24 5.015 5.013 0 2.773-2.24 5.012-5.015 5.012z"
                  transform="translate(-312 -120) translate(0 96) translate(312 24)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SearchIcon;
